
import React from "react";
import PropTypes from "prop-types";
import "./FontSpirulina.css"; // contains @font-face

const FontSpirulina = ({
  children,
  size ,
  color = "#000",
  weight = "normal",
  background = "transparent", 
  padding = "0px 5px",  
  borderRadius = "10px",

}) => {
  const style = {
    fontFamily: "Angelos-Personal, sans-serif",
    fontSize: size,
    color: color,
    fontWeight: weight,
    background: background,
    padding: background !== "transparent" ? padding : undefined,
    borderRadius:borderRadius,
  };

  return <span style={style}>{children}</span>;
};

FontSpirulina.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  background: PropTypes.string,
  padding: PropTypes.string,
};

export default FontSpirulina;
